import throttle from '../../utils/throttle'
import location from '../../utils/location'
import metadata from '../../utils/metadata'
import store from '../../components/last-seen-store'

function update (current, position, props) {
  const duration = current.metadata.duration
    ? metadata.parseDurationToSeconds(current.metadata.duration)
    : null

  const item = {
    id: current.id,
    title: current.title,
    images: current.posters,
    position,
    duration,
    url: props.path,
    recommendations: {
      contentId: props.recommendationsContentId,
      name: current.title
    }
  }

  store.update(item)
}

function configure (ludoPlayer) {
  const recommendationsContentId =
    document.querySelector('.program[data-recommendations-content-id]')
      .getAttribute('data-recommendations-content-id')

  const path =
    location.path()

  const props = {
    recommendationsContentId,
    path
  }

  const callback =
    () => update(ludoPlayer.current(), ludoPlayer.currentTime(), props)

  ludoPlayer.on('timeupdate', throttle(callback, 5000))
  ludoPlayer.on('seeked', callback)
}

export default {
  configure
}
